import { createStore, applyMiddleware, combineReducers, compose } from 'redux'
import thunk from 'redux-thunk'

import helpersReducer from '../Reducers/HelpersReducer'
import pokemonReducer from '../Reducers/PokemonReducer'
import stylesReducer from '../Reducers/StylesReducer'

const rootReducer = combineReducers({
    helpers: helpersReducer,
    pokemon: pokemonReducer,
    themes: stylesReducer
})

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(thunk))
)

export default store